import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles<string, { imageToRight?: boolean }>(
  () => ({
    root: {
      padding: [Spacings.s64, Spacings.s0],

      [mediaQuery(BreakPoints.Large)]: {
        padding: [Spacings.s40, Spacings.s0],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    content: {
      display: 'flex',
      columnGap: 80,
      flexDirection: props => (props.imageToRight ? 'row-reverse' : 'row'),
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        flexDirection: props => (props.imageToRight ? 'column-reverse' : 'column'),
        justifyContent: 'center',
        alignItems: 'start',
      },
    },
    imageContainer: {
      height: 558,
      width: 478,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        width: '100%',
        maxWidth: 478,
        marginBottom: Spacings.s40,
      },
    },
    image: {
      height: '100%',
      width: '100%',
      '& img': {
        borderRadius: CornerRadius.r16,
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        objectFit: 'cover',
      },
    },
    // Skeleton
    linesContainer: {
      width: '100%',
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        maxWidth: 550,
      },
    },
    heading: {
      height: 40,
    },
    title: {
      height: 16,
      marginTop: Spacings.s32,
    },
    subtitle: {
      height: 8,
      marginTop: CornerRadius.r8,
    },
  }),
  {
    name: 'image-with-list',
  },
);

export default useStyles;
